const SESSION_INFO_KEY = 'sm_session_info';

export default SESSION_INFO_KEY;
